import { Injectable, inject } from '@angular/core';
import { GeneralProjectService } from '@app/cem/project/services/general-project.service';
import { PxdAgEditGridDefaultColumnDef, PxdAgGridColumnTypes, PxdAgGridOptions, PxdAgGridSideBarOptions, PxdAgGridStatusBarOptions } from '@app/shared/aggrid/pxd-ag-grid-options';
import { PxdAgGridSelectEditorComponent } from '@app/shared/aggrid/pxd-ag-grid-select-editor';
import { DefaultProjectTeam } from 'app/shared/models';

export interface DefaultTeamFracFleet {
  FracFleetId?: number;
  DefaultFracFleetId?: number;
  StimDefaultProjectTeamId?: number;
  PostStimDefaultProjectTeamId?: number;
  Name: string;
}

export class ProjectTeamFracFleetGridOptions implements PxdAgGridOptions {
  enableCharts = true;
  cellSelection = true;
  rowGroupPanelShow: 'always' | 'onlyWhenGrouping' | 'never' = 'always';
  editType: 'fullRow' = 'fullRow';
  defaultColDef = PxdAgEditGridDefaultColumnDef;
  statusBar = PxdAgGridStatusBarOptions;
  sideBar = PxdAgGridSideBarOptions;
  columnTypes = PxdAgGridColumnTypes;
  columnDefs = [];
}

@Injectable({
  providedIn: 'root'
})
export class ProjectTeamFracFleetGridOptionsService {
  public generalProjectService = inject(GeneralProjectService);

  public projectTeamFracFleetGridOptions: ProjectTeamFracFleetGridOptions = new ProjectTeamFracFleetGridOptions();

  public constructor() {
    this.projectTeamFracFleetGridOptions.columnDefs = this.columnDefs;
  }
  DefaultProjectTeams: Map<number, DefaultProjectTeam> = new Map();

  getDefaultProjectTeam = (id) => {
    if (!id) return '';
    let dteam = this.DefaultProjectTeams.get(id);
    if (dteam) return dteam.Description;
    return '';
  }

  columnDefs = [
    { field: 'FracFleetId', editable: false },
    { field: 'Name', headerName: 'FracFleet Name', editable: false },
    {
      field: 'StimDefaultProjectTeamId', headerName: 'Stim Default Project Team',
      cellRenderer: params => {
        return this.getDefaultProjectTeam(params.value);
      },
      cellEditorSelector: params => {
        return {
          component: PxdAgGridSelectEditorComponent,
          params: {
            values: Array.from(this.DefaultProjectTeams.values()).map(d => {
              return { value: d.DefaultProjectTeamId, text: d.Description };
            })
          }
        };
      }
    },
    {
      field: 'PostStimDefaultProjectTeamId', headerName: 'Post Stim Default Project Team',
      cellRenderer: params => {
        return this.getDefaultProjectTeam(params.value);
      },
      cellEditorSelector: params => {
        return {
          component: PxdAgGridSelectEditorComponent,
          params: {
            values: Array.from(this.DefaultProjectTeams.values()).map(d => {
              return { value: d.DefaultProjectTeamId, text: d.Description };
            })
          }
        };
      }
    }
  ];
}